module.exports = __webpack_public_path__ + "img/payment-american.30cdd58f.png";